__turbopack_context__.v({
  "browse": "WorkbenchPage-module__CS8iOG__browse",
  "comment": "WorkbenchPage-module__CS8iOG__comment",
});
